import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f78534c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ranking-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "city-select",
  class: "title"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }),
  /*#__PURE__*/_createTextVNode(" AQI城市排名 ")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("本市各区")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("本省各市")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全国各市")
const _hoisted_7 = { class: "aqi" }

import {
  computed, reactive, ref, watch, onMounted,withDefaults,
} from 'vue';
import {
  Select, Table, ConfigProvider, Tag,
} from 'ant-design-vue';
import { useStore, } from 'vuex';
import qs from 'qs';

import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { factorColorRender, fontColorRender, } from '@/utils/index';

interface Props {
  listLength: number,
}

export default /*#__PURE__*/_defineComponent({
  props: {
    listLength: { default: 10 }
  },
  setup(__props: any, { expose }) {

const props = __props as { listLength: number }

const store = useStore();

const { Option, } = Select;



// 当前城市id
const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;

//  当前省id
const proviceId = computed<string>(() => store.state.OLMap.regionId.slice(0,2).padEnd(12,'0'));

// 详情页面包屑切换城市id
const selectCityId = computed(() => store.state.airStatus.selectCityId);

// 下拉框选中类型
const selectType = ref('city');

/**
 * 加载本市各区
 * @return {void}
 */
const loadAQIRankingList = () => {
  const params = qs.stringify({
    regionId: regionId.value,
  });

  store.dispatch('gateway/loadAQIRankingList', params);
};

/**
 * 加载本省各市
 * @return {void}
 */
const loadAQICityRankingList = () => {
  const params = qs.stringify({
    regionId: proviceId.value || '320100000000',
    indexName: 'AQI',
  });

  store.dispatch('gateway/loadAQICityRankingList', params);
};

onMounted(() => {
  if (regionId.value) {
    loadAQIRankingList();
  }
  if (proviceId.value) {
    loadAQICityRankingList();
  }
});

watch([regionId,proviceId,], ([curRe, curPr,], [oldRe, oldSe,]) => {
  if (curRe) {
    loadAQIRankingList();
  }
  if (curPr) {
    loadAQICityRankingList();
  }
});

// 加载全国各市
store.dispatch('gateway/loadAQICityRankingList', qs.stringify({ regionId: '', indexName: 'AQI', }));

// 列表行配置
const columns = reactive([
  {
    title: '倒序',
    slots: { customRender: 'key', },
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '城市（区域）',
    dataIndex: 'pointName',
    key: 'pointName',
  },
  {
    title: 'AQI',
    dataIndex: 'aqi',
    key: 'aqi',
    slots: { customRender: 'aqi', },
  },
]);

const getPopupContainer = () => document.getElementById('city-select');

// 初始化列表集合
const initData = computed(() => {
  const temp = store.state.gateway.AQICityRankingList;

  temp.splice(props.listLength, temp.length);

  return temp;
});

// 切换选项列表数据集合
const dataSource = ref();

/**
 * 下拉框值改变触发函数
 * @param {string} value 下拉框值
 * @return {void}
 */
const handleChange = (value: string) => {
  const { AQICityRankingList, AQIProvinceRankingList, AQICountryRankingList, } = store.state.gateway;

  switch (value) {
  case 'city':
    AQICityRankingList.splice(props.listLength, AQICityRankingList.length);
    dataSource.value = AQICityRankingList;
    columns[1].dataIndex = 'pointName';
    columns[2].dataIndex = 'aqi';
    break;
  case 'province':
    AQIProvinceRankingList.splice(props.listLength, AQIProvinceRankingList.length);
    dataSource.value = AQIProvinceRankingList;
    columns[1].dataIndex = 'cityName';
    columns[2].dataIndex = 'avgIndex';
    break;
  case 'country':
    AQICountryRankingList.splice(props.listLength, AQICountryRankingList.length);
    dataSource.value = AQICountryRankingList;
    columns[1].dataIndex = 'cityName';
    columns[2].dataIndex = 'avgIndex';
    break;
  default:
    columns[1].dataIndex = 'pointName';
  }
};

watch(selectCityId, (curid) => {
  const params = qs.stringify({
    regionId: curid,
  });

  store.dispatch('gateway/loadAQIRankingList', params);

  const params2 = qs.stringify({
    regionId: curid.slice(0, 2).padEnd(12, '0') || '320100000000',
    indexName: 'AQI',
  });

  store.dispatch('gateway/loadAQICityRankingList', params2);

  selectType.value = 'city';
  setTimeout(() => {
    handleChange(selectType.value);
  },1000);
});

/**
 * 列表前三索引背景色配置
 * @param {number} key 索引
 * @return {string} 色值
 */
const setTopThreeColor = (key: number): string | undefined => {
  switch (key) {
  case 1:
    return '#ff3547';
  case 2:
    return '#ff8039';
  case 3:
    return '#ffc224';
  default:
    break;
  }
};

const rankingRef = ref<any | null>(null);

expose({
  rankingRef,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "ranking",
    ref_key: "rankingRef",
    ref: rankingRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(Select), {
          placeholder: "当前城市区域排名",
          value: selectType.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectType).value = $event)),
          dropdownStyle: { textAlign: 'center',},
          getPopupContainer: getPopupContainer,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Option), { value: "city" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_unref(Option), { value: "province" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_unref(Option), { value: "country" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_unref(Table), {
            columns: _unref(columns),
            "data-source": dataSource.value ? dataSource.value : _unref(initData),
            pagination: false
          }, {
            key: _withCtx(({ text }) => [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_unref(Tag), {
                  color: setTopThreeColor(text)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(text), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ])
            ]),
            aqi: _withCtx(({ text: aqi }) => [
              _createElementVNode("span", null, [
                _createVNode(_unref(Tag), {
                  color: _unref(factorColorRender)(aqi, 'aqi'),
                  style: _normalizeStyle({color: aqi? _unref(fontColorRender)(Number(aqi), 'aqi') : _unref(fontColorRender)(-9999, 'aqi')})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(aqi && aqi !== '-9999' ? Number(aqi).toFixed(0) : '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "style"])
              ])
            ]),
            _: 1
          }, 8, ["columns", "data-source"])
        ]),
        _: 1
      }, 8, ["locale"]),
      _createElementVNode("div", {
        class: "btn-air-detail",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/index/airRanking')))
      }, "实时空气质量排名全览")
    ])
  ], 512))
}
}

})